module.exports = __webpack_public_path__ + "img/Partners13.7b244923.png";